import { render } from "./GiftAddView.vue?vue&type=template&id=1a1bfa93"
import script from "./GiftAddView.vue?vue&type=script&lang=js"
export * from "./GiftAddView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__